const english = {
  pageTitle: "Ledger Entry",
  sl: "SL",
  transactionID: "Transaction ID",
  transactionNumber: "Transaction Number",
  transactionDate: "Transaction Date",
  paymentMethod: "Payment Method",
  status: "Status",
  entryDate: "Entry Date",
  action: "Action",
  createLedgerEntry: "Create Ledger Entry",
  editLedgerEntry: "Edit Ledger Entry",
  add: "Add",
  edit: "Edit",
  selectDate: "Select Date",
  selectPaymentMethod: "Select Payment Method",
  enterLedgerDetails: "Enter Ledger Details",
  select: "Select",
  save: "Save",
  update: "Update",
  close: "Close",
  selectLedger: "Select Ledger",
};
const malay = {
  pageTitle: "Entri Lejar",
  sl: "SL",
  transactionID: "ID Transaksi",
  transactionNumber: "Nombor Transaksi",
  transactionDate: "Tarikh Transaksi",
  paymentMethod: "Kaedah Pembayaran",
  status: "Status",
  entryDate: "Tarikh Entri",
  action: "Tindakan",
  createLedgerEntry: "Buat Entri Lejar",
  editLedgerEntry: "Edit Entri Lejar",
  add: "Tambah",
  edit: "Edit",
  selectDate: "Pilih Tarikh",
  selectPaymentMethod: "Pilih Kaedah Pembayaran",
  enterLedgerDetails: "Masukkan Butiran Lejar",
  select: "Pilih",
  selectLedger: "Pilih Lejar",
  enterAmount: "Masukkan Amaun",
  save: "Simpan",
  update: "Kemas Kini",
  close: "Tutup",
};

const thai = {
  pageTitle: "รายการบัญชีแยกประเภท",
  sl: "ลำดับ",
  transactionID: "รหัสธุรกรรม",
  transactionNumber: "หมายเลขธุรกรรม",
  transactionDate: "วันที่ทำธุรกรรม",
  paymentMethod: "วิธีการชำระเงิน",
  status: "สถานะ",
  entryDate: "วันที่บันทึก",
  action: "การดำเนินการ",
  createLedgerEntry: "สร้างรายการบัญชีแยกประเภท",
  editLedgerEntry: "แก้ไขรายการบัญชีแยกประเภท",
  add: "เพิ่ม",
  edit: "แก้ไข",
  selectDate: "เลือกวันที่",
  selectPaymentMethod: "เลือกวิธีการชำระเงิน",
  enterLedgerDetails: "ป้อนรายละเอียดบัญชีแยกประเภท",
  select: "เลือก",
  selectLedger: "เลือกบัญชีแยกประเภท",
  enterAmount: "ป้อนจำนวนเงิน",
  save: "บันทึก",
  update: "อัปเดต",
  close: "ปิด",
};

const arabic = {
  pageTitle: "إدخال دفتر الأستاذ",
  sl: "الرقم التسلسلي",
  transactionID: "معرف المعاملة",
  transactionNumber: "رقم المعاملة",
  transactionDate: "تاريخ المعاملة",
  paymentMethod: "طريقة الدفع",
  status: "الحالة",
  entryDate: "تاريخ الإدخال",
  action: "الإجراء",
  createLedgerEntry: "إنشاء إدخال دفتر الأستاذ",
  editLedgerEntry: "تعديل إدخال دفتر الأستاذ",
  add: "إضافة",
  edit: "تعديل",
  selectDate: "اختر التاريخ",
  selectPaymentMethod: "اختر طريقة الدفع",
  enterLedgerDetails: "أدخل تفاصيل دفتر الأستاذ",
  select: "اختر",
  selectLedger: "اختر دفتر الأستاذ",
  enterAmount: "أدخل المبلغ",
  save: "حفظ",
  update: "تحديث",
  close: "إغلاق",
};

const bengali = {
  pageTitle: "লেজার এন্ট্রি",
  sl: "ক্রম",
  transactionID: "লেনদেন আইডি",
  transactionNumber: "লেনদেন নম্বর",
  transactionDate: "লেনদেনের তারিখ",
  paymentMethod: "পেমেন্ট পদ্ধতি",
  status: "অবস্থা",
  entryDate: "এন্ট্রি তারিখ",
  action: "কর্ম",
  createLedgerEntry: "লেজার এন্ট্রি তৈরি করুন",
  editLedgerEntry: "লেজার এন্ট্রি সম্পাদনা করুন",
  add: "যোগ করুন",
  edit: "সম্পাদনা করুন",
  selectDate: "তারিখ নির্বাচন করুন",
  selectPaymentMethod: "পেমেন্ট পদ্ধতি নির্বাচন করুন",
  enterLedgerDetails: "লেজার বিবরণ লিখুন",
  select: "নির্বাচন করুন",
  selectLedger: "লেজার নির্বাচন করুন",
  enterAmount: "পরিমাণ লিখুন",
  save: "সংরক্ষণ করুন",
  update: "আপডেট করুন",
  close: "বন্ধ করুন",
};

export const ledgerEntryLang = {
  english,
  malay,
  thai,
  arabic,
  bengali,
};
